/** @namespace $route.current */
/** @namespace $route.current.params */

const _ = require('lodash');

module.exports = ["$scope", "$q", "ChannelRepository", "AppConstants", "AppLanguage", "CTServiceAPI", "EventTracker", "Prefill", function($scope, $q, ChannelRepository, AppConstants, AppLanguage, CTServiceAPI, EventTracker, Prefill) {
    const _controller         = this,
          _channel            = ChannelRepository.get(AppConstants.CHANNEL_SUBMISSION.NAME),
          _channelSocialMedia = ChannelRepository.get(AppConstants.CHANNEL_SOCIALMEDIA.NAME);

    let _networkActivity = false,
        _fbEmail         = false,
        _currentStep     = 1,
        _currentSection  = 0;

    _controller.error = {};

    // Parent Controller
    _controller.smc = $scope.socialmediaconnect;


    _controller.isEmpty = _.isEmpty;

    /**
     * Validates The Input Fields, and sets flags if required fields ar not set
     * TODO: DRY Solution please
     */
    _controller.validateFields = () => {
        _controller.error = {};

        /**
         * Reference to the FOrm
         */
        let form = $scope.GRCreate;

        /**
         * If Property name not set
         */
        if(form.name.$invalid) {

            _controller.error.name = true;

            /**
             * Watch returns a Function for deregistration
             */
            let _deleteWatch = $scope.$watch(() => _controller.data.name, (newValue, oldValue) => {

                // If nothing happened, exit
                if(newValue === oldValue) return;

                delete _controller.error.name;

                _deleteWatch();

            });

        }

        /**
         * If Property Description not set
         */
        if(form.description.$invalid) {

            _controller.error.description = true;

            /**
             * Watch returns a Function for deregistration
             */
            let _deleteWatch = $scope.$watch(() => _controller.data.description, (newValue, oldValue) => {

                // If nothing happened, exit
                if(newValue === oldValue) return;

                delete _controller.error.description;

                _deleteWatch();

            });

        }

        /**
         * If Property Description not set
         */
        if((form.personname.$invalid || form.personsurname.$invalid || form.personemail.$invalid) && !_controller.smc.usesFacebook(_controller)) {

            _controller.error.person = true;

            /**
             * Watch returns a Function for deregistration
             */
            let _deleteWatch = $scope.$watch(() => JSON.stringify(_controller.data.person), (newValue, oldValue) => {

                // If nothing happened, exit
                if(newValue === oldValue) return;
                if((form.personname.$invalid || form.personsurname.$invalid || form.personemail.$invalid) && !_controller.smc.usesFacebook(_controller)) return;

                delete _controller.error.person;

                _deleteWatch();

            });

        }

    };

    /**
     * Submit Flags
     * @type {boolean}
     */
    _controller.submitted = false;
    _controller.errorOnSubmit = false;


    /**
     * Indicates the State of different sections
     * @type {{title: {open: boolean}, description: {open: boolean}, sujet: {open: boolean}, goal: {open: boolean}, person: {open: boolean}, submit: {submitted: boolean}}}
     */
    _controller.section = {
        title: {
            open: true          // First Section. Set Open by Default
        },

        description: {
            open: false
        },

        sujet: {
            open: false
        },

        goal: {
            open: false
        },

        person: {
            open: false
        },

        submit: {
            open     : false,
            submitted: false
        }
    };

    /**
     * Initialize disclaimer_accepted only when config Value is set
     * @param val
     */
    _controller.setDisclaimerAccepted = function(val) {
        // AppConstants.ACCEPT_DISCLAIMER_ENABLED set in default.blade.php
        if (AppConstants.ACCEPT_DISCLAIMER_ENABLED) {
            _controller.data.disclaimer_accepted = val;
        }
    };


    /**
     * Opens a section on Click
     * If Toggle Flag set to false. the function just opens the Secton
     * @type {{}}
     */
    _controller.toggleSection = (panel, toggle = true) => {
        switch(panel) {
            case 'title':
                _controller.section.title.open = (toggle) ? !(_controller.section.title.open) : true;
                break;
            case 'description':
                _controller.section.description.open = (toggle) ? !(_controller.section.description.open) : true;
                break;
            case 'goal':
                _controller.section.goal.open = (toggle) ? !(_controller.section.goal.open) : true;
                break;
            case 'sujet':
                _controller.section.sujet.open = (toggle) ? !(_controller.section.sujet.open) : true;
                break;
            case 'person':
                _controller.section.person.open = (toggle) ? !(_controller.section.person.open) : true;
                break;

            case 'submit':
                _controller.section.submit.open = (toggle) ? !(_controller.section.submit.open) : true;
                break;
        }
    };

    /**
     * Check if the given section should be visible
     * @param section
     */
    _controller.showSection = (panel) => _controller.section[panel].open;

    /**
     * Set network activity when flag is defined
     * Get when flag is not defined
     *
     * @param {boolean} [flag]
     */
    _controller.hasNetworkActivity = (flag) => {
        if(flag === true || flag === false) {
            return (_networkActivity = flag);
        }
        else {
            return _networkActivity;
        }
    };

    _controller.hasFacebookEmail = () => !!_fbEmail;


    /**
     * Object with Fields that are required
     * @type {{}}
     */
    _controller.required = {};


    _controller.checkRequired = () => {

    };


    _controller.media = {};
    /**
     * React on uploading an image
     *
     * @param image_id
     * @param image_url
     */
    _controller.media.onUploadSujet = (image_id, image_url) => {
        _controller.data.image_id  = image_id;
        _controller.data.image_url = image_url;

        delete _controller.error.imageSujet;
    };

    /**
     * React on removing an images
     */
    _controller.media.onRemoveSujet = () => {
        delete _controller.data.image_url;
        delete _controller.data.image_id;

        delete _controller.error.imageSujet;
    };

    /**
     * React on errors
     */
    _controller.media.onErrorSujet = () => {
        _controller.error.imageSujet = true;
    };

    /**
     * React on uploading an image
     *
     * @param image_id
     * @param image_url
     */
    _controller.media.onUploadPerson = (image_id, image_url) => {
        _controller.data.person.image_id  = image_id;
        _controller.data.person.image_url = image_url;
        delete _controller.error.imagePerson;
    };

    /**
     * React on removing an images
     */
    _controller.media.onRemovePerson = () => {
        delete _controller.data.person.image_url;
        delete _controller.data.person.image_id;
        delete _controller.error.imagePerson;
    };

    /**
     * React on errors
     */
    _controller.media.onErrorPerson = () => {
        _controller.error.imagePerson = true;
    };

    /**
     * Get the current step
     */
    _controller.currentStep = () => _currentStep;

    /**
     * Set a new step
     * @param step
     */
    _controller.setStep = (step) => {
        //Notify about step submission
        _channel.notify(AppConstants.CHANNEL_SUBMISSION.ACTION_STEP, _currentStep);

        //Set the step
        _currentStep = step;
    };

    /**
     * Submit the current step
     */
    _controller.submitStep = () => {
        switch(_controller.currentStep()) {
            case 0:
                _controller.setStep(1);
                break;
            case 1:
                _submitCampaign();
        }
    };

    _controller.resetData = () => {
        _resetData();
        _channel.notify(AppConstants.CHANNEL_SUBMISSION.ACTION_RESET);
    };

    function _resetData() {
        _controller.data = {
            person: {}
        };

        _controller.setDisclaimerAccepted(false);


        delete _controller.error.imagePerson;
        delete _controller.error.imageSujet;

        _fbEmail = false;
    }


    /**
     * Submit the entered data to the API
     * @private
     */
    function _submitCampaign() {
        const _errorHandler      = (error) => console.error(error),
              _successHandler    = () => {
                  // set is Submitted Flag
                  _controller.submitted = true;

                  EventTracker.track(['Cambuildr', 'Grassroots-Kampagne erstellt']);



              },

              _submitHeaderSujet = () => _controller.headerSujet.submitMedia(),
              _submitPersonImage = () => _controller.personImage.submitMedia(),
              _submitData        = () => {
                  if(AppLanguage !== false) {
                      _controller.data.lang        = AppLanguage.code;
                      _controller.data.person.lang = AppLanguage.code;
                  }

                  return CTServiceAPI.post(`/pages/${AppConstants.PAGE_ID}/grassroot_campaigns`, _controller.data);
              };

        _controller.hasNetworkActivity(true);

        $q.resolve()
          .then(_submitHeaderSujet)
          .then(_submitPersonImage)
          .then(_submitData)
          .then(_successHandler, _errorHandler)
          .finally(() => _controller.hasNetworkActivity(false));
    }


    function setFacebookEmail(data, context, itemID) {
        if(context != 'grassroot_campaign') {
            return;
        }
        _fbEmail = data.email;
    }

    //Fetch user image after facebook connect
    function didConnectWithFacebook(fb_data, context) {
        if(context != 'grassroot_campaign') {
            return;
        }
        _controller.hasNetworkActivity(true);

        //Create a promise while communication with FB
        $q((resolve, reject) => {
            //Set the API Call
            FB.api('/me/picture', {
                width : 1920,
                fields: 'is_silhouette,url'
            }, (response) => {
                if(response.data) {
                    resolve(response.data);
                }
                else {
                    reject(response);
                }
            });
        }).then((data) => {

            //If image is no silhouette assign it to the data model
            if(!data.is_silhouette) {
                _controller.media.onUploadPerson(-1, data.url);

                if(_controller.personImage) {
                    _controller.personImage.setMedia(data.url, 'IMG');
                }
            }
        })
          .finally(() => _controller.hasNetworkActivity(false));
    }

    (function init() {
        _resetData();
        _channelSocialMedia.subscribe(AppConstants.CHANNEL_SOCIALMEDIA.ACTION_FB_CONNECT, setFacebookEmail);
        _channelSocialMedia.subscribe(AppConstants.CHANNEL_SOCIALMEDIA.ACTION_FB_CONNECT, didConnectWithFacebook);

        Prefill.prefill(_controller.data, [{
            prop: 'name',
            param: 'campaign'
        }, 'person.name', 'person.surname', 'person.email', 'description'])
    }());
}];
